import React from "react";
import { NavItem } from "reactstrap";

//Common
import useMoreActionsMenuStyles from "../../common/MoreActionsMenu/styles";
import { MoreActionsMenu } from "../../common/MoreActionsMenu";
import { LockIcon } from "../../common/Icons";

//App
import { RoleMoreActionsMenuProps } from "../../../types";

const RoleMoreActionsMenu: React.FC<RoleMoreActionsMenuProps> = (props) => {
  const { onPermissionClick, ...restProps } = props;

  const moreActionMenuStyles = useMoreActionsMenuStyles();

  return (
    <MoreActionsMenu {...restProps}>
      {onPermissionClick && (
        <NavItem
          style={moreActionMenuStyles.navItem}
          onClick={onPermissionClick}
        >
          <LockIcon />
        </NavItem>
      )}
    </MoreActionsMenu>
  );
};

export default RoleMoreActionsMenu;
